module.exports = __webpack_public_path__ + "img/radio-button-selected-disabled.c64dfff2.svg";